export const SMALL_STICKY_HEIGHT = "buttonBar--smallStickyHeight"